<template lang="html">
    <Row>
        <Col :span="24">
            <Card class="card-box card-height">
                <div class="text-center" v-if="isautoCompleteTripCountLoading">
                    <Spinner/>
                </div>
                <div class="status-msg" v-else-if="!autoCompleteTripCount">
                    <span>
                      <svgicon :name="emptyDashboardIcon" width="150" height="115" :original="true" />
                      <p class="mt-0 ml-30">No data available</p>
                    </span>
                </div>
                <Row :gutter="40" v-else>
                <Col :span="12">
                    <div class="header-text">
                        Auto-Complete Trip Summary
                    </div>
                    <Graph
                    :graphDetail="autoCompleteTripCount"
                    :headerConstant="autoCompleteBarChartConstants"
                    :multiline="true"
                    >
                    </Graph>
                </Col>

                <Col :span="12">
                    <Row :gutter="40" class="list-bordered divider col-pt-15">
                        <Col :span="8"  v-for="header in autoCompleteTripCountHeaders" :key="header.id" :class="header.class">
                          <Tooltip :open-delay="100" popper-class="max-width"  effect="dark" placement="top">
                            <div slot="content">
                                <span v-html="trackingDashboard[header.column]"></span>
                            </div>
                            <ColCell
                            :header="header"
                            :value="autoCompleteTripCount[header.column]"
                            @routeToTrack="$emit('routeToTrack', { routeCategory: header.routeCategory, type: header.type, header: $event })"
                            >
                            </ColCell>
                          </Tooltip>
                        </Col>
                    </Row>

                </Col>
                </Row>
            </Card>
        </Col>
    </Row>
</template>

<script>
import ColCell from '@/components/track/ColCell';
import Graph from '@/components/track/Graph';
import {
  etaDetailsHeaders,
  etaBarChartConstants,
  autoCompleteBarChartConstants,
  autoCompleteTripCountHeaders,
} from '@/constants/trackConstants';
import SecFilterMixin from '@common/mixins/SecFilterMixin';

export default {
  components: {
    ColCell,
    Graph,
  },
  mixins: [SecFilterMixin],
  data() {
    return {
      isautoCompleteTripCountLoading: false,
      etaDetailsHeaders,
      etaBarChartConstants,
      autoCompleteTripCountHeaders,
      autoCompleteBarChartConstants,
      autoCompleteTripCount: {},
    };
  },
  props: ['queryParams', 'dashboardConfigs', 'apiTrigger', 'emptyDashboardIcon', 'trackingDashboard'],
  async created() {
    this.apiTrigger.$on('loadMore', (args) => {
      this.search();
    });
  },
  methods: {
    async search() {
      const section = 'autoCompleteTripCount';
      this.isautoCompleteTripCountLoading = true;
      this.autoCompleteResult = await this.$store.dispatch('track/getDashboardDetails',
        { section, params: this.queryParams });
      if (this.autoCompleteResult && !this.autoCompleteResult.error) {
        this.autoCompleteTripCount = this.autoCompleteResult;
      } else {
        this.autoCompleteTripCount = {};
      }
      this.isautoCompleteTripCountLoading = false;
    },
  },

};
</script>
